import { IAppState } from '@store/reducers';
import { IStatusState } from '@store/reducers/status';

export const getAppStatus = (store: IAppState): IStatusState => store.status;
